var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPen = function SvgEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#427CFF",
    d: "m1.722 8.109 5.916-5.92 3.03 3.031-5.916 5.92zm9.704-6.67C10.671.683 9.462.363 8.612 1.214l-.601.602 3.03 3.032.601-.602c.85-.85.535-2.056-.216-2.807M.569 11.592a.63.63 0 0 0 .189.512.63.63 0 0 0 .55.182l2.994-.85L1.426 8.56l-.857 3.034Z"
  })));
};
export { SvgEditPen as ReactComponent };